module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("2HI26"))).then(() => parcelRequire('13hJH'));